import React, { useState, useEffect } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";

import API from "../API_Services/ServiceLayer";
import toast from "react-simple-toasts";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Spinner from "../Shared/Spinner";

import { onFocus } from "./formAnimation";
import "../User-Pages/user.scss";
import { BsEye, BsEyeSlash } from "react-icons/bs";

export const API_URL = process.env.REACT_APP_API_URL;

let count = 1;
const Login = ({ location }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [popup, setPopup] = useState(false);
  const [path, setPath] = useState(null);

  const history = useHistory();

  useEffect(() => {
    let pathname = JSON.parse(localStorage.getItem("pathname"));

    setPath(pathname);
    if (history.location.search.split("?msg=")[1]) {
      const decodedString = atob(history.location.search.split("?msg=")[1]);
      const Content = () => (
        <div className="d-flex justify-content-center align-items-center">
          <h4>{decodedString}.</h4>
        </div>
      );
      const MySwal = withReactContent(Swal);
      MySwal.fire({
        title: "Verification Completed Successfully",
        html: <Content />,
        icon: "success",
        allowOutsideClick: false,
        confirmButtonText: "Proceed to login...",
        customClass: {
          confirmButton: "custom-confirm",
        },
      }).then((result) => {
        if (result.isConfirmed) Swal.close();
      });
    }
    onFocus();
    const user = localStorage.getItem("user");
    if (user) window.location.href = "/discover";
  }, []);

  const handleFormSubmit = (e) => {
    e.preventDefault();

    const { state, pathname } = location;

    let data = {
      email: email,
      password: password,
      role: ["Member", "Employee"],
    };

    setLoading(true);

    API.postMethod("user-management/api/v1/sign-in", "post", data)
      .then((res) => res.json())
      .then((result) => {
        console.log("result", result);
        if (result.status) {
          toast(result.message, 5000);
          // localStorage.setItem("user", JSON.stringify(result.data));
          localStorage.setItem("token", result.data.token);
          localStorage.setItem("token_type", "Bearer");

          let rolesOrdered = [];
          let assignSortOrder = result?.data?.roles?.forEach((role, index) => {
            role.sort_id =
              role.role_name === "Employee"
                ? 1
                : role.role_name === "Member"
                ? 2
                : 9;
            rolesOrdered.push(role);
          });

          let sortedRoleOrder = rolesOrdered.sort(
            (a, b) => a.sort_id - b.sort_id
          );

          localStorage.setItem(
            "user",
            JSON.stringify({
              ...result?.data,
              roles: rolesOrdered,
              role_id: rolesOrdered[0]?.id,
            })
          );

          console.log("sortedRoleOrder", sortedRoleOrder);
          console.log("singleObject", rolesOrdered[0]?.id);

          setLoading(false);

          setTimeout(() => {
            const queryString = require("query-string");

            const { redirectTo } = queryString.parse(location.search);
            history.push(
              redirectTo == null || redirectTo == undefined
                ? path
                  ? path
                  : "/discover/dashboard"
                : redirectTo
            );
            window.location.reload();
            // if (!!state && state.prevPath) history.goBack();
            // else window.location.href = '/discover/dashboard';
          }, 1000);
        } else {
          if (count === 1) {
            toast(result.message, 5000);
            setPassword("");
            count++;
          }
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };

  // const handleForget = () => {
  //   const MySwal = withReactContent(Swal);

  //   MySwal.fire({
  //     text: 'Enter Email ID',
  //     input: 'text',
  //     inputAttributes: {
  //       autocapitalize: 'off',
  //     },
  //     showCancelButton: true,
  //     cancelButtonColor: '#eee',
  //     confirmButtonText: 'Reset Password',
  //     showLoaderOnConfirm: true,
  //     preConfirm: (email) => {
  //       const data = { email };
  //       console.log('id: ', data);
  //       return API.postMethod('api/forgot-psw', 'post', data)
  //         .then((response) => {
  //           if (!response.ok) {
  //             throw new Error(response.statusText);
  //           }
  //           return response.json();
  //         })
  //         .catch((error) => {
  //           MySwal.showValidationMessage(`Request failed: ${error}`);
  //         });
  //     },
  //     allowOutsideClick: () => !MySwal.isLoading(),
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       MySwal.fire({
  //         text: result.value.message,
  //       });
  //     }
  //   });
  // };

  return (
    <div className="log-page">
      {loading && <Spinner />}
      <div className="logo">
        <a href={API_URL}>
          <img src={require("../../assets/images/user/f-logo.png")} alt="" />
        </a>
      </div>
      <div className="banner-sec">
        <img
          src={require("../../assets/images/login/login-signup.png")}
          alt=""
        />
      </div>
      <div className="form-sec">
        <div className="log-form">
          <form method="post" action="" onSubmit={(e) => handleFormSubmit(e)}>
            <h3 className="title">Welcome!</h3>
            <p className="sub-head">Please login or register</p>
            <div className="inputs-wrapper">
              <div className="input-group">
                <label>Username</label>
                <input
                  type="text"
                  required
                  name="email"
                  onChange={(e) => {
                    setEmail(e.target.value);
                    count = 1;
                  }}
                />
              </div>
              <div className="input-group">
                <label>Password</label>
                <input
                  type={showPassword ? "text" : "password"}
                  required
                  name="password"
                  onChange={(e) => {
                    setPassword(e.target.value);
                    count = 1;
                  }}
                  value={password ? password : ""}
                />
                <button
                  type="button"
                  className="see-password"
                  title="Show Password"
                  onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? <BsEyeSlash /> : <BsEye />}
                </button>
                <Link
                  to="/user-pages/forgot-password"
                  className="forget-password"
                  title="forget password">
                  Forgot Password?
                </Link>
              </div>
            </div>
            <div className="btns">
              {location.pathname === "/user-pages/corporate/login" ? null : (
                <button
                  className="btn"
                  type="button"
                  onClick={() => {
                    window.location.href = "/user-pages/register";
                  }}>
                  <span className="text-left d-inline-block">
                    <small>New User?</small>
                    Register
                  </span>
                </button>
              )}
              <button type="submit" className="btn btn-primary submit">
                SIGN IN <i className="fas fa-arrow-right" />
              </button>
            </div>
            <div className="d-flex justify-content-end mt-2">
              <a
                style={{ fontSize: "16px" }}
                href={API_URL}
                className=" text-primary ">
                Back to home
              </a>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
